export default "__VITE_ASSET__d5f8048b__"